import CreateSetupBackend from '../config/config.js';
import UtilService from './utilService.js';

let SetupBackend = null;

async function createOnboardingPJ(data) {
  await UtilService.getJWT();
  SetupBackend = CreateSetupBackend();

  try {
    return await SetupBackend.post("/v1/kyc/createonboardingpj", data);
  } catch (error) {
    console.error("Erro ao criar onboarding PJ:", error);
    throw error;
  }
}

async function createOnboardingPF(data) {
  await UtilService.getJWT();
  SetupBackend = CreateSetupBackend();

  try {
    return await SetupBackend.post("/v1/kyc/createonboardingpf", data);
  } catch (error) {
    console.error("Erro ao criar onboarding PF:", error);
    throw error;
  }
}

const backendServices = {
  createOnboardingPJ,
  createOnboardingPF
};

export default backendServices;